$(function () {
	console.log("Release.js file has been loaded!")

	const counter = () => {
		if ($(".date-checker").length > 0) {
			var releaseClosed = new Date($(".date-checker").data("datechecker"))
			if (releaseClosed.getTime() > new Date().getTime()) {
				countdown(
					releaseClosed,
					function (ts) {
						if (ts.days == 0 && ts.hours == 0 && ts.minutes == 0 && ts.seconds == 0) {
							$(".date-checker").text("Draw Closed")
						} else {
							$(".date-checker").text("Enter Draw")
						}
					},
					countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS,
				)
			} else {
				$(".date-checker").text("Draw Closed")
			}
		}

		var release_end_date = moment($(".release-time").data("datetime")).tz("CST6CDT")

		$(".draw-closer-date").text(`Draw closes at ${release_end_date.format("MM/DD/YY h:mm a")}`)

		if ($(".release-time")) {
			$(".release-time").each(function () {
				let release_date = moment($(this).data("datetime")).tz("CST6CDT")
				let current_element = $(this)

				if (Number(release_date.format("x")) > Number(moment(new Date()).tz("CST6CDT").format("x"))) {
					countdown(
						release_date.format("x"),
						function (ts) {
							ts.days < 10 ? (ts.days = "0" + ts.days) : ""
							ts.hours < 10 ? (ts.hours = "0" + ts.hours) : ""
							ts.minutes < 10 ? (ts.minutes = "0" + ts.minutes) : ""
							ts.seconds < 10 ? (ts.seconds = "0" + ts.seconds) : ""

							$(current_element).find(".days span").text(ts.days)
							$(current_element).find(".hours span").text(ts.hours)
							$(current_element).find(".minutes span").text(ts.minutes)
							$(current_element).find(".seconds span").text(ts.seconds)
							if (ts.days == 0 && ts.hours == 0 && ts.minutes == 0 && ts.seconds == 0) {
								$(".product-release__inner").fadeOut(function () {
									$(this)
										.html(
											`
                                <h2 style="text-align: center">Draw Closed!</h2>
                            `,
										)
										.fadeIn()
								})
							}
						},
						countdown.DAYS | countdown.HOURS | countdown.MINUTES | countdown.SECONDS,
					)
				} else {
					$(".product-release__inner").fadeOut(function () {
						$(this)
							.html(
								`
                        <h2 style="text-align: center">Draw Closed!</h2>
                    `,
							)
							.fadeIn()
					})
				}
			})
		}
	}
	counter()

	// get customer geo
	async function getGeo() {
		const response = await fetch("https://www.cloudflare.com/cdn-cgi/trace")
		const response_data = await response.text()
		const initialValue = {}
		let jsons = response_data.split("\n").reduce((obj, item) => {
			return {
				...obj,
				[item.split("=")[0]]: item.split("=")[1],
			}
		}, initialValue)
		return jsons
	}

	// tabs steps
	$("[data-current-step]").click(function (e) {
		e.preventDefault()

		const $currentStep = $(this).data("current-step")
		const $prevStep = $(this).data("prev-step")
		const $nextStep = $(this).data("next-step")

		$($currentStep).fadeOut(50)
		if ($prevStep) {
			$($prevStep).fadeIn(50)
		}
		if ($nextStep) {
			$($nextStep).fadeIn(50)
		}
	})
	// tabs steps //

	$("#submit-win").change(function () {
		const $btnReleaseSend = $($("#btn-release-send"))
		if ($(this).is(":checked")) {
			$btnReleaseSend.prop("disabled", false)
		} else {
			$btnReleaseSend.prop("disabled", true)
		}
	})

	$("#sectionShipping").validate({
		// debug: true,
		onsubmit: true,
		errorElement: "span",
		errorClass: "error-msg",
		validClass: "success-msg",
		success: function (label) {
			label.addClass("success-msg").text("Valid!")
		},
		ignore: "#shipping-checkbox",
		rules: {
			shipping__first_name: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			shipping__last_name: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			shipping__phone: {
				required: true,
				intlTelNumber: true, // custom validation method
			},
			shipping__country: {
				required: true,
			},
			shipping__address: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			shipping__city: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			shipping__state: {
				required: true,
			},
			shipping__postcode: {
				required: true,
				digits: true,
				min: 3,
				minlength: 3,
				maxlength: 6,
				pattern: /^[0-9]{5,6}(?:-[0-9]{4})?$/,
			},
			billing__first_name: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			billing__last_name: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			billing__phone: {
				required: true,
				intlTelNumber: true, // custom validation method
			},
			billing__country: {
				required: true,
			},
			billing__address: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			billing__city: {
				required: true,
				minlength: 2,
				maxlength: 50,
			},
			billing__state: {
				required: true,
			},
			billing__postcode: {
				required: true,
				digits: true,
				min: 3,
				minlength: 3,
				maxlength: 6,
				pattern: /^[0-9]{5,6}(?:-[0-9]{4})?$/,
			},
		},
		messages: {
			shipping__first_name: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			shipping__last_name: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			shipping__phone: {
				required: "This input is required!",
			},
			shipping__country: {
				required: "This select is required!",
			},
			shipping__address: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			shipping__city: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			shipping__state: {
				required: "This select is required!",
			},
			shipping__postcode: {
				required: "This input is required!",
				min: jQuery.validator.format("This input required more than {0} numbers!"),
				minlength: jQuery.validator.format("At least {0} numbers!"),
				maxlength: jQuery.validator.format("No more than {0} numbers!"),
				pattern: "This format is invalid!",
			},
			billing__first_name: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			billing__last_name: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			billing__phone: {
				required: "This input is required!",
			},
			billing__country: {
				required: "This select is required!",
			},
			billing__address: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			billing__city: {
				required: "This input is required!",
				minlength: jQuery.validator.format("At least {0} characters!"),
				maxlength: jQuery.validator.format("No more than {0} characters!"),
			},
			billing__state: {
				required: "This select is required!",
			},
			billing__postcode: {
				required: "This input is required!",
				min: jQuery.validator.format("This input required more than {0} numbers!"),
				minlength: jQuery.validator.format("At least {0} numbers!"),
				maxlength: jQuery.validator.format("No more than {0} numbers!"),
				pattern: "This format is invalid!",
			},
		},
		submitHandler: function (form) {
			// alert("Submited!")
			makePayment()
		},
		invalidHandler: function (event, validator) {
			const errors = validator.numberOfInvalids()
			if (errors) {
				$("#stripe-request").css("background-color", "#ff4646").text("Not valid!")
				console.error("Release form not valid! Total errors", errors)
				nativeToast({
					message: `Release form not valid!<br>Total errors ${errors}!`,
					timeout: 5000,
					rounded: true,
					position: "south",
					closeOnClick: true,
					type: "error",
				})
				setTimeout(() => {
					$("#stripe-request").css("background-color", "#000").text("Next")
				}, 2000)
			}
		},
	})

	// iti phone validator
	const $shippingPhone = $("input[name='shipping__phone']")
	const $billingPhone = $("input[name='billing__phone']")

	//-- custom validation method for phone number
	$.validator.addMethod(
		"intlTelNumber",
		function (value, element) {
			return this.optional(element) || $(element).intlTelInput("isValidNumber")
		},
		"Please enter a valid International Phone Number",
	)
	//-- custom validation method for phone number //

	$shippingPhone
		.intlTelInput({
			utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
			customContainer: "iti-shipping",
			nationalMode: false,
			autoPlaceholder: "aggressive",
			separateDialCode: true,
			initialCountry: "auto",
			geoIpLookup: async function (success, failure) {
				try {
					const geo = await getGeo()
					success(geo.loc)
					console.log("Your country info:", geo)
				} catch (error) {
					failure("us")
					console.error(error)
				}
			},
		})
		.on("countrychange", function () {
			if (!this.isShowBilling) {
				const countryData = $shippingPhone.intlTelInput("getSelectedCountryData")
				$billingPhone.intlTelInput("setCountry", countryData.iso2)
			}
		})
	$billingPhone.intlTelInput({
		utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
		customContainer: "iti-shipping",
		nationalMode: false,
		autoPlaceholder: "aggressive",
		separateDialCode: true,
		initialCountry: "auto",
		geoIpLookup: async function (success, failure) {
			try {
				const geo = await getGeo()
				success(geo.loc)
				console.log("Your country info:", geo)
			} catch (error) {
				failure("us")
				console.error(error)
			}
		},
	})

	$("#shipping-form input").keyup(function () {
		if ($("#shipping-checkbox").is(":checked")) {
			updateReleaseData()
		}
	})

	$("#shipping-checkbox").click(function () {
		if ($(this).is(":checked")) {
			$("#billing-form").slideUp()
		} else {
			$("#billing-form").slideDown()
		}
	})

	$("#shipping-country").change(function () {
		$(this).attr("code", $(this).val())
		if ($("#shipping-checkbox").is(":checked")) {
			$("#billing-country").attr("code", $("#shipping-country").attr("code"))
			$("#billing-country").val($("#shipping-country").find("option:selected").val())
		}
	})

	$("#shipping-state").change(function () {
		$(this).attr("code", $(this).val())
		if ($("#shipping-checkbox").is(":checked")) {
			$("#billing-state").attr("code", $("#shipping-state").attr("code"))
			$("#billing-state").val($("#shipping-state").find("option:selected").val())
		}
	})

	$("#billing-country").change(function () {
		$(this).attr("code", $(this).val())
	})

	$("#billing-state").change(function () {
		$(this).attr("code", $(this).val())
	})

	function updateReleaseData() {
		if ($("#shipping-checkbox").is(":checked")) {
			$("#billing-first").val($("#shipping-first").val())
			$("#billing-last").val($("#shipping-last").val())
			$("#billing-phone").val($("#shipping-phone").val())
			$("#billing-street").val($("#shipping-street").val())
			$("#billing-city").val($("#shipping-city").val())
			$("#billing-zip").val($("#shipping-zip").val())

			$("#billing-country").attr("code", $("#shipping-country").attr("code"))
			$("#billing-state").attr("code", $("#shipping-state").attr("code"))

			$("#billing-country").val($("#shipping-country").find("option:selected").val())
			$("#billing-state").val($("#shipping-state").find("option:selected").val())
		}
	}

	let stripe, backend_url, clientSecret
	let customerData = {}
	let subtotal = $("[data-subtotal]").data("subtotal")
	let tax = 0
	let shipping = 1200
	let total = 0

	console.log("Production Stripe mode...")
	stripe = Stripe("pk_live_51HQDwGBawR32vtfaXt4x0ipDjmeHrFwG6lQIMXCNg2nIe8UO1H4g0t6HeHr3m1sB4RdVQ5IagTpY84MD2pkivuhY009SOOT5Wb")
	backend_url = "https://special.svrn.com"
	// console.log("Development Stripe mode...")
	// stripe = Stripe("pk_test_51HQDwGBawR32vtfaDnfubrCBslQ8KB9IPGxWCYsrs4o3cS8HpvMchwGtEseOYXxAgsS4uyWUnLALc1UpUB7V7LOd00hXmrVGJk")
	// backend_url = "https://staging-svrn-releases-api-kw69d.ondigitalocean.app"

	const elements = stripe.elements()
	const cardNumber = elements.create("cardNumber")
	const cardExpiry = elements.create("cardExpiry")
	const cardCvc = elements.create("cardCvc")

	const $submitButton = $($("#stripe-request"))
	const $entryButton = $($("#btn-release-send"))
	const submitButtonText = $submitButton.text()
	const entryButtonText = $entryButton.text()

	async function makePayment() {
		customerData = {
			email: $("#customerData").data("customer-email"),
			firstName: $("#customerData").data("customer-first-name"),
			lastName: $("#customerData").data("customer-last-name"),
			shopifyCustomerId: $("#customerData").data("customer-id").toString(),
			shippingAddress: {
				firstName: $("#shipping-first").val(),
				lastName: $("#shipping-last").val(),
				phone: $("#shipping-phone").val(),
				street: $("#shipping-street").val(),
				city: $("#shipping-city").val(),
				zip: $("#shipping-zip").val(),
				state: $("#shipping-state").attr("code"),
				countryCode: $("#shipping-country").attr("code"),
				address: $("#shipping-street").val(),
			},
			billingAddress: {
				firstName: $("#billing-first").val(),
				lastName: $("#billing-last").val(),
				phone: $("#billing-phone").val(),
				street: $("#billing-street").val(),
				city: $("#billing-city").val(),
				zip: $("#billing-zip").val(),
				state: $("#billing-state").attr("code"),
				countryCode: $("#billing-country").attr("code"),
				address: $("#billing-street").val(),
			},
		}
		console.log("Customer Data", customerData)

		try {
			$submitButton.text("Loading")

			let responseIntent = await fetch(`${backend_url}/customers/get-intent`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(customerData) })
			if (!responseIntent.ok) {
				throw new Error("Fetching error -  '/customers/get-intent'")
			}

			cardNumber.mount("#card-form .cardNumber-section")
			cardExpiry.mount("#card-form .cardExpiry-section")
			cardCvc.mount("#card-form .cardCvc-section")
			console.log("Card Data mounted!")

			responseIntent = await responseIntent.json()
			if (responseIntent) {
				console.log("[/customers/get-intent]The card is configured successfully!", responseIntent)
				nativeToast({
					message: "The card is<br/>configured successfully!",
					timeout: 5000,
					rounded: true,
					position: "east",
					closeOnClick: true,
					type: "success",
				})

				clientSecret = responseIntent.clientSecret

				const states = ["illinois", "il"]
				if (states.includes(customerData.shippingAddress.state.toLowerCase())) {
					let taxPercents = 10.25
					tax = Math.round(((subtotal + shipping) / 100) * taxPercents)
					$("[data-tax]")
						.data("tax", tax)
						.text(`$${tax / 100}`)
				}
				let total = subtotal + tax + shipping
				$("[data-total]").text(`$${total / 100}`)

				console.log("Total calculated.")

				$submitButton.text("Checked")
				setTimeout(() => {
					$submitButton.text("Next")
					$("#sectionShipping").fadeOut(function () {
						$("#sectionPayment").fadeIn(function () {
							console.log("Form Customer Data closed. Form Payment opened!")
// 							$("#btn-release-send").prop("disabled", false)
						})
					})
				}, 1000)
			}
		} catch (error) {
			console.error("Received client intent error!", error)
			nativeToast({
				message: `Received client intent error!<br/>Please, reload the page!`,
				timeout: 5000,
				rounded: true,
				position: "east",
				closeOnClick: true,
				type: "error",
			})

			$submitButton.css("background-color", "#ff4646").text("Error!")
			setTimeout(() => {
				$submitButton.css("background-color", "#000").text(submitButtonText)
			}, 2000)
		}
	}

	$("#btn-release-send").off("click")
	$("#btn-release-send").click(async function () {
		try {
			$entryButton.text("Loading...")
			console.log("Fetching card setup...")

			const responseSetup = await stripe.confirmCardSetup(clientSecret, {
				payment_method: {
					type: "card",
					card: cardNumber,
				},
			})

			if (responseSetup.error) {
				console.error("Card Setup error", responseSetup.error)
				nativeToast({
					message: `${responseSetup.error.message}`,
					timeout: 5000,
					rounded: true,
					position: "east",
					closeOnClick: true,
					type: "error",
				})

				$entryButton.css("background-color", "#ff4646").text("Error!")
				setTimeout(() => {
					$entryButton.css("background-color", "#000").text(entryButtonText)
				}, 2000)
				return
			}

			if (responseSetup.setupIntent.status === "succeeded") {
				console.log("Need to subscribe to klaviyo? Bool:", $("#submit-newsletter").is(":checked"))

				const entryData = {
					productId: $("#customerData").data("product-id").toString(),
					productName: $("#customerData").data("product-name").toString(),
					variantId: $("#size_options input:checked").val().toString(),
					variantName: $("#size_options input:checked").data("variant-name").toString(),
					releaseDate: new Date($("#customerData").data("release-date")).toISOString(),
					shipping: shipping.toString(),
					tax: tax.toString(),
					total: total.toString(),
					shopifyCustomerId: customerData.shopifyCustomerId,
					shippingAddress: customerData.shippingAddress,
					billingAddress: customerData.billingAddress,
					subscribed: $("#submit-newsletter").is(":checked"),
				}
				console.log("Entry Data", entryData)

				let responseEntry = await fetch(`${backend_url}/entry/create`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(entryData) })
				responseEntry = await responseEntry.json()
				if (responseEntry == true) {
					console.log("Entry Created...")

					$entryButton.text("Entry Created!")
					nativeToast({
						message: "Entry Created!",
						timeout: 5000,
						rounded: true,
						position: "south",
						closeOnClick: true,
						type: "success",
					})

					setTimeout(() => {
						$(".product-release__inner").fadeOut(function () {
							$(this)
								.html(
									`
                                        <h2 style="text-align: center">Thank you for entering!</h2>
                                        </br>
                                        <p style="text-align: center; color: grey;">Your submission has been recorded. If you win the draw, you will be notified via email and the information you provided will be used to deliver your pair.</p>
                                    `,
								)
								.fadeIn()
						})

						cardNumber.unmount()
						cardExpiry.unmount()
						cardCvc.unmount()
						console.log("Card data unmounted...")
					}, 1750)
				} else {
					if (responseEntry.message.includes("duplicate key value")) {
						$(".product-release__inner").fadeOut(function () {
							$(this)
								.html(
									`
                                        <h2 style="text-align: center">Information</h2>
                                        </br>
                                        <p style="text-align: center; color: grey;">We have already received an entry with the same size for this account. Only one size is allowed per customer.</p>
                                    `,
								)
								.fadeIn()
						})
						cardNumber.unmount()
						cardExpiry.unmount()
						cardCvc.unmount()
						console.log("Card data unmounted...")
					} else {
						throw responseEntry
					}
				}
			}
		} catch (error) {
			const errorString = typeof error === "string" ? error : "Entry creation error.<br/>Please, reload the page and try again!"
			console.error("Entry creation error", error)

			nativeToast({
				message: errorString,
				timeout: 5000,
				rounded: true,
				position: "east",
				closeOnClick: true,
				type: "error",
			})

			$entryButton.css("background-color", "#ff4646").text("Error!")
			setTimeout(() => {
				$entryButton.css("background-color", "#000").text(entryButtonText)

				cardNumber.unmount()
				cardExpiry.unmount()
				cardCvc.unmount()
				console.log("Card data unmounted...")
			}, 2000)
		}
	})
})
